import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Инициализация карты с OpenStreetMap (полностью бесплатно, без токенов)
    const map = L.map(this.element, {
      attributionControl: false
    }).setView([57.88, 59.89], 13)

    // Слой карты OpenStreetMap
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 19
    }).addTo(map)
    
    // Загрузка GPX файла
    fetch('/map.gpx')
      .then(response => response.text())
      .then(gpxData => {
        // Парсинг GPX
        const parser = new DOMParser()
        const gpx = parser.parseFromString(gpxData, 'text/xml')
        
        // Получаем все точки трека
        const trkpts = gpx.querySelectorAll('trkpt')
        const latlngs = []
        
        trkpts.forEach(trkpt => {
          const lat = parseFloat(trkpt.getAttribute('lat'))
          const lon = parseFloat(trkpt.getAttribute('lon'))
          latlngs.push([lat, lon])
        })
        
        // Рисуем линию маршрута
        if (latlngs.length > 0) {
          const polyline = L.polyline(latlngs, {
            color: '#14b8a6', // teal-500
            weight: 5,
            opacity: 0.9,
            smoothFactor: 1
          }).addTo(map)
          
          // Маркер старта
          L.marker(latlngs[0], {
            icon: L.divIcon({
              className: 'custom-marker',
              html: '<div style="background-color: #10b981; width: 32px; height: 32px; border-radius: 50%; border: 4px solid white; box-shadow: 0 4px 6px rgba(0,0,0,0.3);"></div>',
              iconSize: [32, 32],
              iconAnchor: [16, 16]
            })
          }).addTo(map).bindPopup('<strong>Старт</strong>')
          
          // Маркер финиша
          L.marker(latlngs[latlngs.length - 1], {
            icon: L.divIcon({
              className: 'custom-marker',
              html: '<div style="background-color: #ef4444; width: 32px; height: 32px; border-radius: 50%; border: 4px solid white; box-shadow: 0 4px 6px rgba(0,0,0,0.3);"></div>',
              iconSize: [32, 32],
              iconAnchor: [16, 16]
            })
          }).addTo(map).bindPopup('<strong>Финиш</strong>')
          
          // Подгоняем карту под маршрут
          map.fitBounds(polyline.getBounds(), { padding: [50, 50] })
        }
      })
      .catch(error => {
        console.error('Ошибка загрузки GPX:', error)
      })
  }
}
